import React from "react";
import { Link } from "react-router-dom";

function Breadcrumb({ items }) {
  return (
    <nav className="breadcrumb">
      <div className="breadcrumb-elements">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {/* 1. Item Container */}
            <div className="breadcrumb-item">
              {item.to ? (
                <Link to={item.to} className="breadcrumb-link">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icons/blog_gray.svg`}
                    alt="icon"
                    className="breadcrumb-icon"
                  />
                  <span>{item.label}</span>
                </Link>
              ) : (
                <span className="current">{item.label}</span>
              )}
            </div>

            {/* 2. Separator Container (Only between items) */}
            {index < items.length - 1 && (
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/breadcrumb_separator_gray.svg`}
                alt="separator"
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
}

export default Breadcrumb;
